//  @flow
import { Box, Grid, Typography } from '@material-ui/core';
import { motion } from 'framer-motion';
import { InView } from 'react-intersection-observer';
import { Link } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

import BgImage from '../../styled/BgImage';
import pointer from '../../../images/pointer.png';

type Props = {
  images: Array<any>,
  index: number,
  name: string,
  slug: string,
};

const useStyles = makeStyles((theme) => ({
  rectangle: {
    width: '100%',
    height: 282,
    margin: 0,
    color: theme.palette.primary.main,
    zIndex: 100,
    backgroundColor: 'white',
    transform: `scale(1)`,
    transition: `all 0.${theme.transitions.duration.standard}s ${theme.transitions.easing.sharp}`,
    '&:hover': {
      cursor: `url(${pointer}), auto`,
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      transition: `all 0.${theme.transitions.duration.standard}s ${theme.transitions.easing.sharp}`,
      zIndex: 100,
    },
  },
  title: {
    fontWeight: 'normal',
    color: 'inherit',
  },
  image: {
    backgroundColor: 'black',
  },
  logoContainer: {
    visibility: 'hidden',

    '&:hover': {
      visibility: 'visible',
    },
  },
  logo: {
    width: 200,
  },
  link: {
    cursor: `url(${pointer}), auto`,
  },
}));

const GalleryColumn = ({ index, images, name, slug }: Props) => {
  const classes = useStyles();
  const arr = index % 2 !== 0 ? [1, images[0], 1] : [images[0], 1, images[1]];

  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  return (
    <>
      {arr.map((item, idx) => {
        if (typeof item === 'object') {
          return (
            <InView threshold={0.5}>
              {({ inView, ref }) => (
                <Grid
                  animate={inView ? 'visible' : 'hidden'}
                  ref={ref}
                  variants={variants}
                  transition={{ duration: 0.7, ease: 'easeOut' }}
                  component={motion.div}
                  className={classes.rectangle}
                  item
                  xs={12}
                  lg={12}
                >
                  <Link to={`/project/${slug}`} className={classes.link}>
                    <BgImage image={item.fluid.srcWebp} height="282px" />
                  </Link>
                </Grid>
              )}
            </InView>
          );
        }

        return (
          <InView threshold={0.5}>
            {({ inView, ref }) => (
              <Grid
                animate={inView ? 'visible' : 'hidden'}
                ref={ref}
                variants={variants}
                transition={{ duration: 0.7, ease: 'easeOut' }}
                component={motion.div}
                xs={12}
                lg={12}
                className={classes.rectangle}
              >
                <Box
                  className={classes.rectangle}
                  display="flex"
                  p={5}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Link to={`/project/${slug}`} className={classes.link}>
                    <Typography
                      className={classes.title}
                      variant="h4"
                      component="div"
                    >
                      {idx === 0 ? ' ' : name}
                    </Typography>
                  </Link>
                </Box>
              </Grid>
            )}
          </InView>
        );
      })}
    </>
  );
};

export default GalleryColumn;
